import React, { useContext, useState } from 'react'
import Grid from '@mui/material/Grid2';
import GlobalTextfield from '../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import styles from '../../Styles/ComponentStyles/GlobalComponentStyles/CredentialDialog.module.scss'
import dialogStyles from "../../Styles/ComponentStyles/GlobalComponentStyles/AppClientMarketingDialog.module.scss"

import globalStyles from "../../Styles/global.module.scss"
import { Alert, IconButton, InputAdornment, Typography } from '@mui/material';
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import agent from '../../Services/api';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { useIsBelow600 } from '../../Utils/Constant/Constant';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';



const CredentialsDialog = (props: any) => {

    const {
        setFlagLoader,
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { getRedtailSSO, setCurrentAppUrl, setFlagCredentialDialog, } = props

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });

    const [errors, setErrors] = useState({
        username: '',
        password: '',
    });
    const [showPassword, setShowPassword] = useState(false)
    const [showCredErrors, setShowCredErrors] = useState(null)
    const { showSnackbar } = useSnackbar();
    const isBelow600 = useIsBelow600();


    // Handle field changes
    const handleChange = (field: string, value: string) => {
        setShowCredErrors(null)
        setFormData({
            ...formData,
            [field]: value,
        });

        // Clear the error for the field when typing
        setErrors({
            ...errors,
            [field]: '',
        });
    };

    // Validate the form fields
    const validateFields = () => {
        let valid = true;
        const newErrors = { username: '', password: '' };

        if (!formData.username.trim()) {
            newErrors.username = 'Username is required.';
            valid = false;
        }

        if (!formData.password.trim()) {
            newErrors.password = 'Password is required.';
            valid = false;
        } else if (formData.password.length < 8) {
            newErrors.password = 'Password must be at least 8 characters long.';
            valid = false;
        }

        setErrors(newErrors);
        setShowCredErrors(null)
        return valid;
    };

    const handleSave = async (action: string) => {
        setShowCredErrors(null)
        let payload = {
            userName: formData.username,
            password: formData.password
        }

        if (validateFields()) {
            setFlagLoader(true)
            const response: any = await agent?.redtailCredentialAPI?.post(payload)
            console.log("response of redtailCredentialAPI", response);
            if (response?.status) {
                if (action == "Save") {
                    console.log("Credentials saved successfully.");
                    setFlagCredentialDialog(false);
                    showSnackbar("Credentials saved successfully!", "success");
                    setFlagLoader(false)
                }
                else if (action == "SaveAndContinue") {
                    const userKey = response.data?.userKey;
                    if (userKey) {
                        showSnackbar("Credentials saved successfully!", "success");
                        setCurrentAppUrl(userKey);
                        getRedtailSSO(userKey);
                        setFlagCredentialDialog(false);
                    }
                    else {
                        const error = response?.error?.message
                        if (error == "Invalid Login Attempt (Incorrect Username and/or Password)") {
                            showSnackbar(
                                <div><strong>Redtail!</strong>
                                    <br />
                                    Invalid credentials. Account may be locked after multiple failed attempts.
                                </div>,
                                'error'
                            );
                        }
                        else {
                            showSnackbar(
                                <div><strong>Error!</strong>
                                    <br />
                                    {error}
                                </div>,
                                'error'
                            );
                        }
                        // setShowCredErrors(error)
                    }
                    setFlagLoader(false)
                }
            }
            else {
                console.log("response of cred false", response);
                setFlagLoader(false)
                const error = response?.error?.message
                if (error == "Invalid Login Attempt (Incorrect Username and/or Password)") {
                    showSnackbar(
                        <div><strong>Redtail!</strong>
                            <br />
                            Invalid credentials. Account may be locked after multiple failed attempts.
                        </div>,
                        'error'
                    );
                }
                else {
                    showSnackbar(
                        <div><strong>Redtail!</strong>
                            <br />
                            {error}
                        </div>,
                        'error'
                    );
                }
            }
        }

    };

    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }} sx={{ padding: isBelow600 ? "8px" : "15px" }}>
                    <Grid container>
                        {showCredErrors &&
                            <Grid size={{ xs: 12 }} className={styles.credErrorTextItem}>
                                <Alert severity="error">{showCredErrors}</Alert>
                            </Grid>
                        }

                        <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px" }}>
                            <Grid container>
                                <Grid size={12} sx={{ margin: "0px 0px 8px" }}>
                                    <Typography
                                        component={'span'}
                                        className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                    >
                                        Username
                                    </Typography>
                                </Grid>
                                <Grid size={12}>
                                    <GlobalTextfield
                                        size='medium'
                                        fullWidth
                                        value={formData.username}
                                        stylingClassName={`${globalStyles.globalFieldStyles}`}
                                        onChange={(e: any) => handleChange('username', e.target.value)}
                                        error={!!errors.username}
                                        helperText={errors.username}
                                        spellCheck={false}
                                        autoComplete="new-password"
                                        inputProps={{
                                            autoComplete: "new-password",
                                            name: Math.random().toString(),
                                            form: { autoComplete: "off" }
                                        }}
                                        onFocus={(event: any) => {
                                            event.target.removeAttribute('autocomplete');
                                            event.target.setAttribute('autocomplete', 'new-password');
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "10px 0px" }}>
                            <Grid container>
                                <Grid size={12} sx={{ margin: "0px 0px 8px" }}>
                                    <Typography
                                        component={'span'}
                                        className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}
                                    >
                                        Password
                                    </Typography>
                                </Grid>
                                <Grid size={12}>
                                    <GlobalTextfield
                                        size='medium'
                                        fullWidth
                                        error={!!errors.password}
                                        stylingClassName={`${globalStyles.globalFieldStyles}`}
                                        helperText={errors.password}
                                        type={showPassword ? 'text' : 'password'}
                                        value={formData.password}
                                        onChange={(e: any) => handleChange('password', e.target.value)}
                                        autoComplete="new-password"
                                        spellCheck={false}
                                        inputProps={{
                                            autoComplete: "new-password",
                                            name: Math.random().toString(),
                                            form: { autoComplete: "off" }
                                        }}
                                        onFocus={(event: any) => {
                                            event.target.removeAttribute('autocomplete');
                                            event.target.setAttribute('autocomplete', 'new-password');
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start" sx={{ margin: '0px', borderLeft: "1px solid #CFD9E0" }}>
                                                    <IconButton
                                                        edge="start"
                                                        size='small'
                                                        onClick={() => { setShowPassword((prev) => !prev); }}
                                                        sx={{
                                                            margin: "0px 10px 0px 5px",
                                                        }}
                                                    >
                                                        {showPassword ?
                                                            <VisibilityOff
                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                            /> :
                                                            <Visibility
                                                                sx={{ fontSize: "23px", color: "#718096" }}
                                                            />
                                                        }
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            "& .MuiInputBase-root": { paddingRight: "0px !important" }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ margin: "30px 0px 20px" }}>
                            <Grid container sx={{ justifyContent: "space-between", gap: "15px" }}>
                                <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 5.5 }} className={`${styles.credDialogCancelBtnItem}`}>
                                    <GlobalButton
                                        value={'Cancel'}
                                        size='large'
                                        fullWidth
                                        className={dialogStyles.closeBtnStyle}
                                        onClick={() => { setShowCredErrors(null); setFlagCredentialDialog(false); }}
                                    />
                                </Grid>
                                <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 5.5 }} className={`${styles.credDialogSaveBtnItem}`}>
                                    <GlobalButton
                                        value={'Save'}
                                        size='large'
                                        fullWidth
                                        className={dialogStyles.globalSsoBtnStyles}
                                        onClick={() => {
                                            handleSave("Save")
                                        }}
                                    />
                                </Grid>
                                <Grid size={{ xl: 4.5, lg: 4.5, md: 4.5, sm: 4.5, xs: 12 }} className={`${styles.credDialogSaveAndGoItem}`}>
                                    <GlobalButton
                                        value={'Save & Go to Site'}
                                        size='large'
                                        fullWidth
                                        className={styles.saveAndGoBtnStyles}
                                        onClick={() => { handleSave("SaveAndContinue") }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CredentialsDialog